/** Busca global: escopos, hits e o agrupamento devolvido pela API. */
import { z } from "zod";
import { label } from "./labels.js";

/* ---------- Busca ---------- */
export const searchScope = z.enum(["tudo", "conversas", "mensagens", "contatos", "etiquetas"]);
export const searchKind = z.enum(["message", "conversation", "contact", "label"]);

export const searchHit = z.object({
  kind: searchKind,
  id: z.string(),
  conversationId: z.string().nullable(),
  title: z.string(),
  snippet: z.string(),
  at: z.string().nullable(),
  channelName: z.string().nullable().optional(),
  labels: label.array().optional(),
  assignee: z.object({ id: z.string(), name: z.string() }).nullable().optional(),
});
export type SearchHit = z.infer<typeof searchHit>;

export const searchResults = z.object({
  groups: z.array(z.object({ kind: searchKind, hits: z.array(searchHit) })),
  scope: searchScope.default("tudo"),
});
export type SearchResults = z.infer<typeof searchResults>;
